import React from 'react'
import { withIcon } from '../../withIcon'

function CartIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.375 3C3.375 2.65482 3.65482 2.375 4 2.375H6C6.34518 2.375 6.625 2.65482 6.625 3V4.41805L20.0445 5.37659C20.2175 5.38894 20.3776 5.47261 20.4865 5.60759C20.5953 5.74257 20.6432 5.91671 20.6187 6.08839L19.6187 13.0884C19.5747 13.3963 19.311 13.625 19 13.625H6.625V16.375H17C18.4497 16.375 19.625 17.5503 19.625 19C19.625 20.4497 18.4497 21.625 17 21.625C15.5503 21.625 14.375 20.4497 14.375 19C14.375 18.4958 14.5171 18.0249 14.7635 17.625H8.2365C8.48287 18.0249 8.625 18.4958 8.625 19C8.625 20.4497 7.44975 21.625 6 21.625C4.55025 21.625 3.375 20.4497 3.375 19C3.375 17.7656 4.227 16.7303 5.375 16.4499V5.00645C5.37496 5.00259 5.37496 4.99872 5.375 4.99484V3.625H4C3.65482 3.625 3.375 3.34518 3.375 3ZM6.625 5.67124V12.375H18.4579L19.2864 6.57562L6.625 5.67124ZM6 17.625C5.24061 17.625 4.625 18.2406 4.625 19C4.625 19.7594 5.24061 20.375 6 20.375C6.75939 20.375 7.375 19.7594 7.375 19C7.375 18.2406 6.75939 17.625 6 17.625ZM17 17.625C16.2406 17.625 15.625 18.2406 15.625 19C15.625 19.7594 16.2406 20.375 17 20.375C17.7594 20.375 18.375 19.7594 18.375 19C18.375 18.2406 17.7594 17.625 17 17.625Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CartIcon)
